const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-section">
        <h3>Latest Services</h3>
        <ul>
          <li>Luxury Home Interiors</li>
          <li>Modern Office Designs</li>
          <li>Customized Furniture</li>
        </ul>
      </div>

      <div className="footer-section">
        <h3>Contact Us</h3>
        <p>Email: connect@orangehomeinteriors.com</p>
        <p>Phone: +91 9620248244</p>
        <p>Location: Bangalore, India</p>
      </div>

      <div className="footer-section">
        <h3>Follow Us</h3>
        <div className="social-icons">
          <a href="https://www.instagram.com/orange_home_interiors?igsh=MWc3Y3ppYWUxeDV0ZA==">📘 Facebook</a>
          <a href="https://www.instagram.com/orange_home_interiors?igsh=MWc3Y3ppYWUxeDV0ZA==">📷 Instagram</a>
          <a href="https://www.instagram.com/orange_home_interiors?igsh=MWc3Y3ppYWUxeDV0ZA==">🐦 Twitter</a>
        </div>
      </div>

      <div className="footer-section">
        <h3>Subscribe</h3>
        <input type="email" placeholder="Enter your email" />
        <button>Subscribe</button>
      </div>
    </footer>
  );
};

export default Footer;
